/* eslint-disable @typescript-eslint/no-explicit-any */
import { services } from '../services/hub.service';

interface Res {
  data: {
    data: any;
    [key: string]: any;
  };
}

export const waitlistActions = {
  getWaitlist,
};

// Community-hub waitlist submissions. Uses GET /api/v1/waitlist/list (admin).
function getWaitlist(): Promise<any> {
  return services.get<Res>(`/waitlist/list?limit=500`).then((promise) => {
    if (promise && 'data' in promise) return promise.data;
    console.log('error in actions get waitlist');
    return Promise.reject('Error fetching waitlist');
  });
}
